import { useEffect, useState } from 'react';
import { opsApi } from '../../api/client';
import { formatCurrency } from '../../lib/currency';

const STATUS_COLORS = { PAID: 'bg-green-100 text-green-800', OPEN: 'bg-yellow-100 text-yellow-800', FAILED: 'bg-red-100 text-red-800', CANCELLED: 'bg-red-100 text-red-700', EXPIRED: 'bg-gray-100 text-gray-600' };

export default function OpsPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    opsApi.payments({ status: filter, limit: 100 }).then(r => {
      if (!cancelled) setPayments(r.data);
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [filter]);

  return (
    <div data-testid="ops-payments" className="p-8">
      <div className="mb-6"><h1 className="text-2xl font-bold text-gray-900">Payments</h1><p className="text-sm text-gray-500 mt-1">Payment records from Mollie / test mode</p></div>

      <div className="flex gap-2 mb-6">
        {['', 'PAID', 'OPEN', 'FAILED', 'CANCELLED', 'EXPIRED'].map(s => (
          <button key={s} onClick={() => setFilter(s)}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${filter === s ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:border-gray-400'}`}>
            {s || 'All'}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="space-y-2">{[...Array(5)].map((_, i) => <div key={`payments-skeleton-${i}`} className="h-12 bg-gray-100 rounded-lg animate-pulse" />)}</div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Mollie ID</th>
                <th className="px-4 py-3 text-left font-semibold">Order</th>
                <th className="px-4 py-3 text-right font-semibold">Amount</th>
                <th className="px-4 py-3 text-center font-semibold">Status</th>
                <th className="px-4 py-3 text-left font-semibold">Paid At</th>
                <th className="px-4 py-3 text-left font-semibold">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {payments.map(p => (
                <tr key={p._id} className="hover:bg-gray-50/50">
                  <td className="px-4 py-3 font-mono text-xs text-gray-700">{p.molliePaymentId}</td>
                  <td className="px-4 py-3">{p.order ? <span className="font-mono font-semibold">#{p.order.orderNumber}</span> : '—'}</td>
                  <td className="px-4 py-3 text-right font-semibold">{formatCurrency(p.amount)}</td>
                  <td className="px-4 py-3 text-center"><span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${STATUS_COLORS[p.status] || 'bg-gray-100 text-gray-600'}`}>{p.status}</span></td>
                  <td className="px-4 py-3 text-gray-500">{p.paidAt ? new Date(p.paidAt).toLocaleString('nl-BE') : '—'}</td>
                  <td className="px-4 py-3 text-gray-500">{p.created_at ? new Date(p.created_at).toLocaleDateString('nl-BE') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!payments.length && <p className="text-center py-12 text-gray-400 text-sm">No payments found</p>}
        </div>
      )}
    </div>
  );
}
